import ENV from "app/utils/ENV";
import React from "react";
import { StyleSheet, View, TouchableOpacity, TextInput } from "react-native";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import "app/utils/react-confirm-alert.css"; // Import css

// import { StyleContext } from "app/contexts/Style";

let alertModule = {
  async confirm({ buttons = [], title = "", subtitle = "" }) {
    const options = {
      title,
      message: subtitle,
      buttons,
      // childrenElement: () => <div style={{backgroundColor: 'red', color: 'white', fontSize: 20}}>Children Element?</div>,
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              backgroundColor: colors.fill,
              padding: sizes.large,
              borderRadius: 5,
            }}
          >
            <h1 style={{ color: colors.foreground }}>{title}</h1>
            <p style={{ color: colors.foreground }}>{subtitle}</p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {buttons
                  .filter((b) => b.style != "cancel")
                  .map((b, i) => (
                    <button
                      key={i}
                      style={{
                        padding: sizes.base,
                        marginRight: sizes.large,
                        backgroundColor:
                          b.style == "destructive"
                            ? "red"
                            : b.style == "secondary"
                            ? colors.fill
                            : colors.foreground,
                        color:
                          b.style == "destructive"
                            ? colors.lightForeground
                            : b.style == "secondary"
                            ? colors.foreground
                            : colors.fill,
                        borderRadius: 5,
                      }}
                      autoFocus={i == 0 ? true : false}
                      onClick={() => {
                        b.onClick && b.onClick();
                        onClose();
                      }}
                    >
                      {b.label}
                    </button>
                  ))}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                {buttons
                  .filter((b) => b.style == "cancel")
                  .map((b, i) => (
                    <button
                      key={i}
                      style={{
                        padding: sizes.base,
                        backgroundColor: colors.trim,
                        color: colors.foreground,
                        borderRadius: 5,
                      }}
                      onClick={() => {
                        b.onClick && b.onClick();
                        onClose();
                      }}
                    >
                      {b.label}
                    </button>
                  ))}
              </div>
            </div>
          </div>
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => {},
      afterClose: () => {},
      onClickOutside: () => {},
      onKeypressEscape: () => {},
    };

    return confirmAlert(options);
  },
};

export default alertModule;
